import initialState from './initialState';
import { RECEIVE_ACCOUNT_REP_DATA } from '../actions/actionTypes';

export default function accountRepData(state = initialState.accountRepData, action) {
  switch (action.type) {
    case RECEIVE_ACCOUNT_REP_DATA:
      return action.accountRepData;
    default:
      return state;
  }
}
